import React from 'react'
import { RouteHandler, Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import { config } from 'config'
import SiteNav from '../SiteNav'
import SiteLinks from '../SiteLinks'
import './style.css'
import profilePic from '../../pages/images/photo.jpg'

class Header extends React.Component {
    render() {
        const {location, children} = this.props
        const isHome = location.pathname === prefixLink('/')

        let div = (
        <div>
          { isHome ? (
            <div>
              <h1 className="title">
                <Link style={ {    textDecoration: 'none',    borderBottom: 'none',    color: 'inherit'} } to={ prefixLink('/') }> { config.siteAuthor } </Link>
                <small className="tagline">{ config.siteTagline }</small>
              </h1>
            </div>
            ) :
            <div>
              <h1 className="title">
                <Link style={ {    textDecoration: 'none',    borderBottom: 'none',    color: 'inherit'} } to={ prefixLink('/') }> { config.siteAuthor } </Link>
                <small className="tagline">{ config.siteTagline }</small>
              </h1>
            </div>
          }
          {/*<p>
          //   { config.siteDescr }
          // </p>*/}
        </div>
        )

        return (
            <header className='header'>
              { div }
            </header>
            );
    }
}

Header.propTypes = {
    children: React.PropTypes.any,
    location: React.PropTypes.object,
}

export default Header



// WEBPACK FOOTER //
// ../components/Header/index.jsx